module.exports = __webpack_public_path__ + "./fonts/SFProDisplay-Bold.ttf";